// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-select[data-v-8cc3e10a]{background-position-x:87%}", "",{"version":3,"sources":["webpack://./modules/frontend/themes/ensotyres/assets/js/components/Checkout/OrderDetails.vue"],"names":[],"mappings":"AACI,8BACI,yBAAR","sourcesContent":["\n    .form-select {\n        background-position-x: 87%;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
